var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(190, 33, 38)",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180,68a52,52,0,1,0-52,52A52.059,52.059,0,0,0,180,68ZM128,96a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,128,96Zm60,24a52,52,0,1,0,52,52A52.059,52.059,0,0,0,188,120Zm0,80a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,188,200ZM68,120a52,52,0,1,0,52,52A52.059,52.059,0,0,0,68,120Zm0,80a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,68,200Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdm2);
export default __webpack_public_path__ + "static/media/adm2.430f4748857f9f008d35baa4191947bc.svg";
export { ForwardRef as ReactComponent };